export function humanize(value) {
    return value
        .split('_')
        .map((word) => (word.length > 0 ? word.charAt(0).toUpperCase() + word.slice(1) : word))
        .join(' ');
}
export function humanizedSelectOptions(values) {
    return values.map((value) => ({ value, label: humanize(value) }));
}
export function errorResponse(err) {
    var _a;
    return (_a = err === null || err === void 0 ? void 0 : err.response) === null || _a === void 0 ? void 0 : _a.data;
}
